// extracted by mini-css-extract-plugin
export default {"header-container":"Inspection_header-container__qXUtM","flex":"Inspection_flex__7mJjK"};